// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#root {
  padding: 0 !important;
}

.login_loginPageContainer__w5lMX {
  width: 100vw;
  height: 100vh;
  display: flex;
}

.login_loginFormContainer__z-ydp {
  height: inherit;
  width: 45vw;
}

.login_loginForm__IXYmz {
  z-index: 1;
  background-color: var(--backgroundColor);
  height: inherit;
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: repeat(3, 1fr);
  grid-column-gap: 0px;
  grid-row-gap: 0px;
}
.login_loginForm__IXYmz .login_headerForm__9Bmp- {
  display: flex;
  justify-content: space-between;
  height: 8rem;
  z-index: 1;
  align-items: center;
  margin-right: 2.5rem;
}
.login_loginForm__IXYmz .login_headerForm__9Bmp- .iu-icon-world2 {
  font-size: 1.375rem;
  color: var(--primaryColor);
  cursor: pointer;
}
.login_loginForm__IXYmz .login_channel__bVTML {
  letter-spacing: 0.15rem;
  color: var(--mainColor);
  font-size: 1.5rem;
  position: relative;
  z-index: 1;
  margin-left: 2rem;
  font-family: var(--fontDosisBold);
  font-weight: normal;
}
.login_loginForm__IXYmz .login_channel__bVTML span {
  font-family: var(--fontDosisRegular);
}
.login_loginForm__IXYmz .login_formContainer__3oD86 {
  z-index: 1;
  position: relative;
  place-self: center;
  width: 23.125rem;
}
.login_loginForm__IXYmz .login_formContainer__3oD86 .login_formTitle__OhqLL {
  font-size: 1.5rem;
  font-family: var(--fontDosisBold);
  color: var(--textsAndComponentTitleColor);
  font-weight: normal;
  text-transform: uppercase;
  margin-bottom: 2rem;
}
.login_loginForm__IXYmz .login_formContainer__3oD86 .login_form__t5Qxn {
  width: 18.4375rem;
  margin: 0 auto;
}
.login_loginForm__IXYmz .login_formContainer__3oD86 .login_form__t5Qxn .login_formControl__Fg2Pl {
  margin-bottom: 1.5rem;
}
.login_loginForm__IXYmz .login_formContainer__3oD86 .login_form__t5Qxn .login_formActions__Nx7Df {
  padding-top: 0.5rem;
  display: flex;
  justify-content: center;
  column-gap: 1.5rem;
}
.login_loginForm__IXYmz .login_formContainer__3oD86 .login_form__t5Qxn .login_formActions__Nx7Df button {
  width: 7.625rem;
}
.login_loginForm__IXYmz .login_formContainer__3oD86 .login_formLinks__HKPV0 {
  margin-top: 3.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
}
.login_loginForm__IXYmz .login_footer__Idoec {
  z-index: 1;
  position: relative;
  padding: 0;
  place-self: flex-end;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: 24px;
  row-gap: 0.25rem;
}
.login_loginForm__IXYmz .login_borderSVG__uv4K0 {
  position: absolute;
  left: 45.5vw;
  height: 100vh;
  z-index: 1;
  top: 0%;
  bottom: 0;
}

@media screen and (max-width: 64rem) {
  .login_borderSVG__uv4K0 {
    display: none;
  }
}
@media screen and (max-width: 48rem) {
  .login_loginFormContainer__z-ydp {
    height: inherit;
    width: 100%;
  }
  .login_loginFormContainer__z-ydp .login_loginForm__IXYmz {
    grid-template-rows: none;
  }
  .login_loginFormContainer__z-ydp .login_loginForm__IXYmz .login_headerForm__9Bmp- {
    height: auto;
    justify-content: center;
  }
  .login_loginFormContainer__z-ydp .login_loginForm__IXYmz .login_headerForm__9Bmp- button {
    position: absolute;
    right: 1.5rem;
    top: 1.85rem;
  }
  .login_loginFormContainer__z-ydp .login_loginForm__IXYmz .login_channel__bVTML {
    margin-top: 0;
    text-align: center;
    font-size: 1.25rem;
    margin-top: 1.5rem;
  }
  .login_loginFormContainer__z-ydp .login_loginForm__IXYmz .login_formContainer__3oD86 .login_formTitle__OhqLL {
    font-size: 1.25rem;
    margin-top: 1rem;
    text-align: center;
  }
  .login_loginFormContainer__z-ydp .login_loginForm__IXYmz .login_formContainer__3oD86 .login_form__t5Qxn {
    margin: 0 auto;
  }
  .login_loginFormContainer__z-ydp .login_loginForm__IXYmz .login_formContainer__3oD86 .login_formLinks__HKPV0 {
    margin-top: 3.5rem;
    margin-bottom: 4rem;
  }
  .login_loginFormContainer__z-ydp .speeddial-backdrop {
    height: 100vh;
  }
  [data-rsbs-header]:before {
    width: 6.25rem;
    height: 0.375rem;
  }
}
@media screen and (max-width: 30rem) {
  .login_loginFormContainer__z-ydp .login_loginForm__IXYmz .login_channel__bVTML {
    font-size: 1.125rem;
    margin-top: 1.5rem;
  }
  .login_loginFormContainer__z-ydp .login_loginForm__IXYmz .login_formContainer__3oD86 .login_formTitle__OhqLL {
    font-size: 1.125rem;
  }
  .login_loginFormContainer__z-ydp .login_loginForm__IXYmz .login_formContainer__3oD86 .login_formLinks__HKPV0 {
    margin-top: 2rem;
    margin-bottom: 2rem;
  }
  .login_loginFormContainer__z-ydp .login_footer__Idoec {
    padding: 0;
  }
  .login_loginFormContainer__z-ydp .login_footer__Idoec :first-child {
    padding-bottom: 0;
    padding-top: 0;
  }
  .login_loginFormContainer__z-ydp .login_footer__Idoec :last-child {
    padding-top: 0;
    padding-bottom: 1rem;
  }
  .login_loginFormContainer__z-ydp .login_footer__Idoec p a {
    font-size: 0.75rem;
  }
  [data-rsbs-header]:before {
    width: 5rem;
    height: 0.25rem;
  }
}
.login_skeletonWrapper__iX9Ps {
  z-index: 1;
  margin: 0 auto;
}

@media screen and (max-width: 48rem) {
  .login_skeletonWrapper__iX9Ps {
    padding: 2rem 0;
  }
}
.login_loginSlideContainer__oQBRW {
  height: 100%;
  overflow: hidden;
  width: 100%;
  z-index: 0;
  cursor: pointer;
}
.login_loginSlideContainer__oQBRW .login_loginSlideLogo__JAC4G {
  position: absolute;
  top: 2rem;
  left: 2.5rem;
}
.login_loginSlideContainer__oQBRW .login_loginSlideImagen__kCVCs {
  height: inherit;
  width: inherit;
  object-fit: cover;
}
.login_loginSlideContainer__oQBRW .login_loginSlideMessage__DeS6F {
  background: rgba(255, 255, 255, 0.7);
  height: 5.75rem;
  min-width: 23.625rem;
  position: absolute;
  bottom: 8.25rem;
  border-radius: 0px 15px 15px 0px;
  padding: 0.75rem 3.1875rem;
  font-size: 1.625rem;
  text-transform: uppercase;
  color: var(--mainColor);
}
.login_loginSlideContainer__oQBRW .login_loginSlideMessage__DeS6F .login_messageTitle__LVKkr {
  font-family: var(--fontDosisBold);
}
.login_loginSlideContainer__oQBRW .login_loginSlideMessage__DeS6F .login_messageSubtitle__klrjz {
  font-family: var(--fontDosisRegular);
}

.theme-dark .login_loginSlideContainer__oQBRW .login_loginSlideMessage__DeS6F {
  background: rgba(38, 40, 56, 0.7);
  color: var(--mainColor);
}

@media screen and (max-width: 48rem) {
  .login_loginSlideContainer__oQBRW .login_loginSlideMessage__DeS6F {
    height: 5.75rem;
    min-width: 23.625rem;
    position: absolute;
    bottom: 12.375rem;
    padding: 0.75rem 3.1875rem;
    font-size: 1.625rem;
  }
  .speeddial-container {
    bottom: 10rem !important;
  }
}
@media screen and (max-width: 30rem) {
  .login_loginSlideContainer__oQBRW .login_loginSlideLogo__JAC4G {
    position: absolute;
    left: 0;
    right: 0;
    margin: 0 auto;
    height: 2.1875rem;
    width: 10rem;
  }
  .login_loginSlideContainer__oQBRW .login_loginSlideMessage__DeS6F {
    height: 3.3125rem;
    min-width: 12.75rem;
    position: absolute;
    bottom: 12.375rem;
    padding: 9px 32px 9px 24px;
    font-size: 0.875rem;
  }
}
.login_containerLanguage__b6we6 {
  width: 12.5rem !important;
  height: fit-content !important;
  padding: 1.5rem !important;
  margin-top: 0 !important;
}
.login_containerLanguage__b6we6 .p-overlaypanel-content {
  padding: 0 !important;
}
.login_containerLanguage__b6we6 .p-divider.p-divider-horizontal {
  margin: 1rem 0 !important;
}

.login_containerLanguageLabels__NIjqB {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}
.login_containerLanguageLabels__NIjqB p {
  margin-bottom: 0 !important;
}

.login_tituloOverlay__orTBt {
  color: var(--textsAndComponentTitleColor) !important;
  font-size: 0.875rem !important;
  font-family: var(--fontBarlowSemiBold) !important;
  font-weight: normal !important;
}

.login_bodyOverlay__RPcCL {
  color: var(--textsAndComponentTitleColor) !important;
  font-size: 1rem !important;
  font-family: var(--fontBarlowMedium) !important;
  font-weight: normal !important;
  margin: 0 0.5rem 1rem 0.5rem !important;
  cursor: pointer !important;
  -webkit-user-select: none !important;
          user-select: none !important;
}

.overlaypanel-demo:after,
.overlaypanel-demo:before {
  left: 335px !important;
}

.login_loginSlider__w-kEZ {
  height: inherit;
  width: 55vw;
}

@media screen and (max-width: 48rem) {
  .login_loginSlider__w-kEZ {
    width: 100vw;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/login/login.module.scss"],"names":[],"mappings":"AAAA;EACE,qBAAA;AACF;;AAEA;EACE,YAAA;EACA,aAAA;EACA,aAAA;AACF;;AAEA;EACE,eAAA;EACA,WAAA;AACF;;AAEA;EACE,UAAA;EACA,wCAAA;EACA,eAAA;EACA,aAAA;EACA,0BAAA;EACA,kCAAA;EACA,oBAAA;EACA,iBAAA;AACF;AACE;EACE,aAAA;EACA,8BAAA;EACA,YAAA;EACA,UAAA;EACA,mBAAA;EACA,oBAAA;AACJ;AACI;EACE,mBAAA;EACA,0BAAA;EACA,eAAA;AACN;AAGE;EACE,uBAAA;EACA,uBAAA;EACA,iBAAA;EACA,kBAAA;EACA,UAAA;EACA,iBAAA;EAMA,iCAAA;EACA,mBAAA;AANJ;AACI;EACE,oCAAA;AACN;AAME;EACE,UAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;AAJJ;AAMI;EACE,iBAAA;EACA,iCAAA;EACA,yCAAA;EACA,mBAAA;EACA,yBAAA;EACA,mBAAA;AAJN;AAOI;EACE,iBAAA;EACA,cAAA;AALN;AAOM;EACE,qBAAA;AALR;AAQM;EACE,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,kBAAA;AANR;AAQQ;EACE,eAAA;AANV;AAWI;EACE,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AATN;AAaE;EACE,UAAA;EACA,kBAAA;EACA,UAAA;EACA,oBAAA;EACA,cAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gBAAA;AAXJ;AAcE;EACE,kBAAA;EACA,YAAA;EACA,aAAA;EACA,UAAA;EACA,OAAA;EACA,SAAA;AAZJ;;AAgBA;EACE;IACE,aAAA;EAbF;AACF;AAgBA;EACE;IACE,eAAA;IACA,WAAA;EAdF;EAgBE;IACE,wBAAA;EAdJ;EAgBI;IACE,YAAA;IACA,uBAAA;EAdN;EAgBM;IACE,kBAAA;IACA,aAAA;IACA,YAAA;EAdR;EAkBI;IACE,aAAA;IACA,kBAAA;IACA,kBAAA;IACA,kBAAA;EAhBN;EAoBM;IACE,kBAAA;IACA,gBAAA;IACA,kBAAA;EAlBR;EAqBM;IACE,cAAA;EAnBR;EAsBM;IACE,kBAAA;IACA,mBAAA;EApBR;EAyBE;IACE,aAAA;EAvBJ;EA2BA;IACE,cAAA;IACA,gBAAA;EAzBF;AACF;AA4BA;EAGM;IACE,mBAAA;IACA,kBAAA;EA5BN;EAgCM;IACE,mBAAA;EA9BR;EAiCM;IACE,gBAAA;IACA,mBAAA;EA/BR;EAoCE;IACE,UAAA;EAlCJ;EAqCI;IACE,iBAAA;IACA,cAAA;EAnCN;EAsCI;IACE,cAAA;IACA,oBAAA;EApCN;EAwCM;IACE,kBAAA;EAtCR;EA4CA;IACE,WAAA;IACA,eAAA;EA1CF;AACF;AA6CA;EACE,UAAA;EACA,cAAA;AA3CF;;AA8CA;EACE;IACE,eAAA;EA3CF;AACF;AA8CA;EACE,YAAA;EACA,gBAAA;EACA,WAAA;EACA,UAAA;EACA,eAAA;AA5CF;AA8CE;EACE,kBAAA;EACA,SAAA;EACA,YAAA;AA5CJ;AA+CE;EACE,eAAA;EACA,cAAA;EACA,iBAAA;AA7CJ;AAgDE;EACE,oCAAA;EACA,eAAA;EACA,oBAAA;EACA,kBAAA;EACA,eAAA;EACA,gCAAA;EACA,0BAAA;EACA,mBAAA;EACA,yBAAA;EACA,uBAAA;AA9CJ;AAgDI;EACE,iCAAA;AA9CN;AAiDI;EACE,oCAAA;AA/CN;;AAsDI;EACE,iCAAA;EACA,uBAAA;AAnDN;;AAwDA;EAEI;IACE,eAAA;IACA,oBAAA;IACA,kBAAA;IACA,iBAAA;IACA,0BAAA;IACA,mBAAA;EAtDJ;EA0DA;IACE,wBAAA;EAxDF;AACF;AA2DA;EAEI;IACE,kBAAA;IACA,OAAA;IACA,QAAA;IACA,cAAA;IACA,iBAAA;IACA,YAAA;EA1DJ;EA6DE;IACE,iBAAA;IACA,mBAAA;IACA,kBAAA;IACA,iBAAA;IACA,0BAAA;IACA,mBAAA;EA3DJ;AACF;AA+DA;EACE,yBAAA;EACA,8BAAA;EACA,0BAAA;EACA,wBAAA;AA7DF;AA+DE;EACE,qBAAA;AA7DJ;AAiEI;EACE,yBAAA;AA/DN;;AAoEA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;AAjEF;AAmEE;EACE,2BAAA;AAjEJ;;AAqEA;EACE,oDAAA;EACA,8BAAA;EACA,iDAAA;EACA,8BAAA;AAlEF;;AAqEA;EACE,oDAAA;EACA,0BAAA;EACA,+CAAA;EACA,8BAAA;EACA,uCAAA;EACA,0BAAA;EACA,oCAAA;UAAA,4BAAA;AAlEF;;AAwEA;;EAEE,sBAAA;AArEF;;AA0EA;EACE,eAAA;EACA,WAAA;AAvEF;;AA0EA;EACE;IACE,YAAA;EAvEF;AACF","sourcesContent":[":global(#root) {\n  padding: 0 !important;\n}\n\n.loginPageContainer {\n  width: 100vw;\n  height: 100vh;\n  display: flex;\n}\n\n.loginFormContainer {\n  height: inherit;\n  width: 45vw;\n}\n\n.loginForm {\n  z-index: 1;\n  background-color: var(--backgroundColor);\n  height: inherit;\n  display: grid;\n  grid-template-columns: 1fr;\n  grid-template-rows: repeat(3, 1fr);\n  grid-column-gap: 0px;\n  grid-row-gap: 0px;\n\n  .headerForm {\n    display: flex;\n    justify-content: space-between;\n    height: 8rem;\n    z-index: 1;\n    align-items: center;\n    margin-right: 2.5rem;\n\n    :global(.iu-icon-world2) {\n      font-size: 1.375rem;\n      color: var(--primaryColor);\n      cursor: pointer;\n    }\n  }\n\n  .channel {\n    letter-spacing: 0.15rem;\n    color: var(--mainColor);\n    font-size: 1.5rem;\n    position: relative;\n    z-index: 1;\n    margin-left: 2rem;\n\n    span {\n      font-family: var(--fontDosisRegular);\n    }\n\n    font-family: var(--fontDosisBold);\n    font-weight: normal;\n  }\n\n  .formContainer {\n    z-index: 1;\n    position: relative;\n    place-self: center;\n    width: 23.125rem;\n\n    .formTitle {\n      font-size: 1.5rem;\n      font-family: var(--fontDosisBold);\n      color: var(--textsAndComponentTitleColor);\n      font-weight: normal;\n      text-transform: uppercase;\n      margin-bottom: 2rem;\n    }\n\n    .form {\n      width: 18.4375rem;\n      margin: 0 auto;\n\n      .formControl {\n        margin-bottom: 1.5rem;\n      }\n\n      .formActions {\n        padding-top: 0.5rem;\n        display: flex;\n        justify-content: center;\n        column-gap: 1.5rem;\n\n        button {\n          width: 7.625rem;\n        }\n      }\n    }\n\n    .formLinks {\n      margin-top: 3.5rem;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n    }\n  }\n\n  .footer {\n    z-index: 1;\n    position: relative;\n    padding: 0;\n    place-self: flex-end;\n    margin: 0 auto;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    padding-bottom: 24px;\n    row-gap: 0.25rem;\n  }\n\n  .borderSVG {\n    position: absolute;\n    left: 45.5vw;\n    height: 100vh;\n    z-index: 1;\n    top: 0%;\n    bottom: 0;\n  }\n}\n\n@media screen and (max-width: 64rem) {\n  .borderSVG {\n    display: none;\n  }\n}\n\n@media screen and (max-width: 48rem) {\n  .loginFormContainer {\n    height: inherit;\n    width: 100%;\n\n    .loginForm {\n      grid-template-rows: none;\n\n      .headerForm {\n        height: auto;\n        justify-content: center;\n\n        button {\n          position: absolute;\n          right: 1.5rem;\n          top: 1.85rem;\n        }\n      }\n\n      .channel {\n        margin-top: 0;\n        text-align: center;\n        font-size: 1.25rem;\n        margin-top: 1.5rem;\n      }\n\n      .formContainer {\n        .formTitle {\n          font-size: 1.25rem;\n          margin-top: 1rem;\n          text-align: center;\n        }\n\n        .form {\n          margin: 0 auto;\n        }\n\n        .formLinks {\n          margin-top: 3.5rem;\n          margin-bottom: 4rem;\n        }\n      }\n    }\n\n    :global(.speeddial-backdrop) {\n      height: 100vh;\n    }\n  }\n\n  [data-rsbs-header]:before {\n    width: 6.25rem;\n    height: 0.375rem;\n  }\n}\n\n@media screen and (max-width: 30rem) {\n  .loginFormContainer {\n    .loginForm {\n      .channel {\n        font-size: 1.125rem;\n        margin-top: 1.5rem;\n      }\n\n      .formContainer {\n        .formTitle {\n          font-size: 1.125rem;\n        }\n\n        .formLinks {\n          margin-top: 2rem;\n          margin-bottom: 2rem;\n        }\n      }\n    }\n\n    .footer {\n      padding: 0;\n      // display: contents;\n\n      :first-child {\n        padding-bottom: 0;\n        padding-top: 0;\n      }\n\n      :last-child {\n        padding-top: 0;\n        padding-bottom: 1rem;\n      }\n\n      p {\n        a {\n          font-size: 0.75rem;\n        }\n      }\n    }\n  }\n\n  [data-rsbs-header]:before {\n    width: 5rem;\n    height: 0.25rem;\n  }\n}\n\n.skeletonWrapper {\n  z-index: 1;\n  margin: 0 auto;\n}\n\n@media screen and (max-width: 48rem) {\n  .skeletonWrapper {\n    padding: 2rem 0;\n  }\n}\n\n.loginSlideContainer {\n  height: 100%;\n  overflow: hidden;\n  width: 100%;\n  z-index: 0;\n  cursor: pointer;\n\n  .loginSlideLogo {\n    position: absolute;\n    top: 2rem;\n    left: 2.5rem;\n  }\n\n  .loginSlideImagen {\n    height: inherit;\n    width: inherit;\n    object-fit: cover;\n  }\n\n  .loginSlideMessage {\n    background: rgba(255, 255, 255, 0.7);\n    height: 5.75rem;\n    min-width: 23.625rem;\n    position: absolute;\n    bottom: 8.25rem;\n    border-radius: 0px 15px 15px 0px;\n    padding: 0.75rem 3.1875rem;\n    font-size: 1.625rem;\n    text-transform: uppercase;\n    color: var(--mainColor);\n\n    .messageTitle {\n      font-family: var(--fontDosisBold);\n    }\n\n    .messageSubtitle {\n      font-family: var(--fontDosisRegular);\n    }\n  }\n}\n\n:global(.theme-dark) {\n  .loginSlideContainer {\n    .loginSlideMessage {\n      background: rgba(38, 40, 56, 0.7);\n      color: var(--mainColor);\n    }\n  }\n}\n\n@media screen and (max-width: 48rem) {\n  .loginSlideContainer {\n    .loginSlideMessage {\n      height: 5.75rem;\n      min-width: 23.625rem;\n      position: absolute;\n      bottom: 12.375rem;\n      padding: 0.75rem 3.1875rem;\n      font-size: 1.625rem;\n    }\n  }\n\n  :global(.speeddial-container) {\n    bottom: 10rem !important;\n  }\n}\n\n@media screen and (max-width: 30rem) {\n  .loginSlideContainer {\n    .loginSlideLogo {\n      position: absolute;\n      left: 0;\n      right: 0;\n      margin: 0 auto;\n      height: 2.1875rem;\n      width: 10rem;\n    }\n\n    .loginSlideMessage {\n      height: 3.3125rem;\n      min-width: 12.75rem;\n      position: absolute;\n      bottom: 12.375rem;\n      padding: 9px 32px 9px 24px;\n      font-size: 0.875rem;\n    }\n  }\n}\n\n.containerLanguage {\n  width: 12.5rem !important;\n  height: fit-content !important;\n  padding: 1.5rem !important;\n  margin-top: 0 !important;\n\n  :global(.p-overlaypanel-content) {\n    padding: 0 !important;\n  }\n\n  :global(.p-divider) {\n    &:global(.p-divider-horizontal) {\n      margin: 1rem 0 !important;\n    }\n  }\n}\n\n.containerLanguageLabels {\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n\n  p {\n    margin-bottom: 0 !important;\n  }\n}\n\n.tituloOverlay {\n  color: var(--textsAndComponentTitleColor) !important;\n  font-size: 0.875rem !important;\n  font-family: var(--fontBarlowSemiBold) !important;\n  font-weight: normal !important;\n}\n\n.bodyOverlay {\n  color: var(--textsAndComponentTitleColor) !important;\n  font-size: 1rem !important;\n  font-family: var(--fontBarlowMedium) !important;\n  font-weight: normal !important;\n  margin: 0 0.5rem 1rem 0.5rem !important;\n  cursor: pointer !important;\n  user-select: none !important;\n}\n\n\n// // POSICIONAMIENTO DE FLECHA OVERLAY PROFILE\n// // ===============\n:global(.overlaypanel-demo:after),\n:global(.overlaypanel-demo:before) {\n  left: 335px !important;\n}\n// // ===============\n// // POSICIONAMIENTO DE FLECHA OVERLAY PROFILE\n\n.loginSlider {\n  height: inherit;\n  width: 55vw;\n}\n\n@media screen and (max-width: 48rem) {\n  .loginSlider {\n    width: 100vw;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"loginPageContainer": `login_loginPageContainer__w5lMX`,
	"loginFormContainer": `login_loginFormContainer__z-ydp`,
	"loginForm": `login_loginForm__IXYmz`,
	"headerForm": `login_headerForm__9Bmp-`,
	"channel": `login_channel__bVTML`,
	"formContainer": `login_formContainer__3oD86`,
	"formTitle": `login_formTitle__OhqLL`,
	"form": `login_form__t5Qxn`,
	"formControl": `login_formControl__Fg2Pl`,
	"formActions": `login_formActions__Nx7Df`,
	"formLinks": `login_formLinks__HKPV0`,
	"footer": `login_footer__Idoec`,
	"borderSVG": `login_borderSVG__uv4K0`,
	"skeletonWrapper": `login_skeletonWrapper__iX9Ps`,
	"loginSlideContainer": `login_loginSlideContainer__oQBRW`,
	"loginSlideLogo": `login_loginSlideLogo__JAC4G`,
	"loginSlideImagen": `login_loginSlideImagen__kCVCs`,
	"loginSlideMessage": `login_loginSlideMessage__DeS6F`,
	"messageTitle": `login_messageTitle__LVKkr`,
	"messageSubtitle": `login_messageSubtitle__klrjz`,
	"containerLanguage": `login_containerLanguage__b6we6`,
	"containerLanguageLabels": `login_containerLanguageLabels__NIjqB`,
	"tituloOverlay": `login_tituloOverlay__orTBt`,
	"bodyOverlay": `login_bodyOverlay__RPcCL`,
	"loginSlider": `login_loginSlider__w-kEZ`
};
export default ___CSS_LOADER_EXPORT___;
